import DomainCoverageSectionContainer from '../../containers/policy-progress/domain-coverage-section-container';
import MessageVolumeCoverageSectionContainer from '../../containers/policy-progress/message-volume-coverage-section-container';
import PropTypes from 'prop-types';
import React from 'react';

const PolicyProgressReport = ( { onInitialLoad } ) => {
    return (
        <React.Fragment>
            <DomainCoverageSectionContainer onInitialLoad={onInitialLoad} />
            <div className="page-break"></div>
            <MessageVolumeCoverageSectionContainer onInitialLoad={onInitialLoad} />
        </React.Fragment>
    );
};

PolicyProgressReport.propTypes = {
    classes: PropTypes.object,
    onInitialLoad: PropTypes.func
};

export default PolicyProgressReport;
